"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    & > svg {\n        transform: rotate(", "deg);\n        color: ", ";\n        cursor: pointer;\n        transition: all .3s;\n        &:hover {\n            color: black;\n        }\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Row = _styledComponents.default.div(_templateObject());

var Button = _styledComponents.default.div(_templateObject2(), function (_ref) {
  var angle = _ref.angle;
  return angle || 0;
}, function (_ref2) {
  var active = _ref2.active;
  return active ? 'black' : 'rgb(181, 181, 181)';
});

var buttons = [[{
  type: 'topleft',
  icon: _freeSolidSvgIcons.faArrowAltCircleUp,
  angle: -45
}, {
  type: 'top',
  icon: _freeSolidSvgIcons.faArrowAltCircleUp
}, {
  type: 'topright',
  icon: _freeSolidSvgIcons.faArrowAltCircleUp,
  angle: 45
}], [{
  type: 'left',
  icon: _freeSolidSvgIcons.faArrowAltCircleLeft
}, {
  type: 'center',
  icon: _freeSolidSvgIcons.faDotCircle
}, {
  type: 'right',
  icon: _freeSolidSvgIcons.faArrowAltCircleRight
}], [{
  type: 'bottomleft',
  icon: _freeSolidSvgIcons.faArrowAltCircleDown,
  angle: 45
}, {
  type: 'bottom',
  icon: _freeSolidSvgIcons.faArrowAltCircleDown
}, {
  type: 'bottomright',
  icon: _freeSolidSvgIcons.faArrowAltCircleDown,
  angle: -45
}]];

var BackgroundAlignToggler =
/*#__PURE__*/
function (_Component) {
  _inherits(BackgroundAlignToggler, _Component);

  function BackgroundAlignToggler() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BackgroundAlignToggler);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BackgroundAlignToggler)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChange = function (type) {
      _this.props.onChange('backgroundAlign', type);
    };

    return _this;
  }

  _createClass(BackgroundAlignToggler, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var align = this.props.align;
      return _react.default.createElement("div", null, buttons.map(function (row, index) {
        return _react.default.createElement(Row, {
          key: "background-align-row-".concat(index)
        }, row.map(function (button) {
          return _react.default.createElement(Button, {
            key: button.type,
            angle: button.angle,
            active: button.type === align,
            onClick: function onClick() {
              return _this2.onChange(button.type);
            }
          }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: button.icon
          }));
        }));
      }));
    }
  }]);

  return BackgroundAlignToggler;
}(_react.Component);

exports.default = BackgroundAlignToggler;
BackgroundAlignToggler.propTypes = {
  align: _propTypes.default.string,
  onChange: _propTypes.default.func
};
BackgroundAlignToggler.defaultProps = {
  align: 'center'
};